import Vue from 'vue'

// export const getPersonalInfo = params => {
//   return Vue.http.post('/virus/account/getPersonalInfo', params)
// }

export const getServiceTrades = params => {
  return Vue.http.post('/virus/sdk/getServiceTrades', params)
}

export const submit = params => {
  return Vue.http.post('/virus/sdk/securityCheck/submit', params)
}
export const reSubmit = params => {
  return Vue.http.post('/virus/sdk/securityCheck/resubmit', params)
}

export const getSubmitInfo = params => {
  return Vue.http.post('/virus/sdk/getSubmitInfo', params)
}

export const queryList = params => {
  return Vue.http.post('/virus/sdk/queryList', params)
}

export const download = params => {
  return Vue.http.get('/virus/sdk/certification/download', { params })
}

export const getDetail = params => {
  return Vue.http.post('/virus/sdk/getDetail', params)
}
